// NATIVE 
import * as React from 'react';



// INSTALLED 
import { Link, useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Avatar, Box, Card, Chip, Pagination, TablePagination } from '@mui/material';
import { paddingCardsTables, timeToClosedToast } from '../../commons';
import { closeSessionGlobal, corregirTexto, firstLetterUpperCase, hasPemissions, storageGetCurrentUser, usarFuncionesComposicion } from '../../commons/utils';
import { useDispatch, useSelector } from 'react-redux';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import MultipleSnackbars from '../MultipleSnackbars';
import { SnackAlert } from '../SnackAlert';
import { showNumberRowsTable } from '../../commons/utils/values';
import { getSucursalesByPagination, getSucursalesStore, storeActiveSucursal, storeDesactiveSucursal, storeDetailSucursal } from '../../store/sucursal';
import { deepOrange } from '@mui/material/colors';
import { AvatarTables } from '../AvatarTables';



// CUSTOM 



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));





/**
 * TableSucursal component renders a table with information about different branches.
 * 
 * The table includes columns for:
 * - Number
 * - Logo
 * - Name
 * - Address
 * - Business Name
 * - Business Logo
 * - Document
 * - Email
 * - Actions
 * 
 * The actions column includes a button that opens a menu with options to view details, edit, or deactivate the branch.
 * 
 * @component
 * @example
 * return (
 *   <TableSucursal />
 * )
 * 
 * @returns {JSX.Element} A table displaying branch information with action buttons.
 */
export const TableSucursal = () => {


  // DISPATCH 
  const dispatch = useDispatch();



  // NAVIGATION
  const navigate = useNavigate();


  // REDUX
  const  {  sucursales_list }:any  = useSelector( (state:any) => state.sucursales );


  // USE STATE 
  const [dataTableList, setDataTable] = React.useState([]);
  const [pagination, setPagination] = React.useState<any>({
      "page": 1,
      "take": 1,
      "itemCount": 1,
      "pageCount": 1,
      "hasPreviousPage": false,
      "hasNextPage": false
  });


  // USE STATE 
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
  const [pagePagination, setPagePagination] = React.useState(1);
  const [itemCountPagination, setItemCountPagination] = React.useState(1);


  const [logoUrl, setLogoUrl] = React.useState('');


  const [openElem, setOpenElem] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


  const [companyName, setCompanyName] = React.useState('N/A');
  
  
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


   const [percentage, setPercentage] = React.useState(0);

  const [canEdit, setCanEdit]     = React.useState<boolean>(false);
  const [canDelete, setCanDelete]     = React.useState<boolean>(false);
  const [canRestore, setCanRestore]     = React.useState<boolean>(false);



  // USE EFFECT 
  React.useEffect(() => {
    
    if ( sucursales_list.data && sucursales_list.data.length > 0 ) {

      setDataTable(sucursales_list.data);
      setPagination({
        "page": sucursales_list.meta.page,
        "take": sucursales_list.meta.take,
        "itemCount": sucursales_list.meta.itemCount,
        "pageCount": sucursales_list.meta.pageCount,
        "hasPreviousPage": sucursales_list.meta.hasPreviousPage,
        "hasNextPage": sucursales_list.meta.hasNextPage
      });
      setItemCountPagination(sucursales_list.meta.pageCount);
      
    }
    

  }, [sucursales_list]);

  React.useEffect(() => {
    getDataTableSucursal();
  }, []);



  React.useEffect(() => {
      setCompanySucursal();
    }, []);



    React.useEffect(() => {
      checkEdit()
    }, []);
  
    React.useEffect(() => {
        checkCanDelete()
    }, []);
  
    React.useEffect(() => {
      checkRestore()
    }, []);



  
    const setCompanySucursal = async() => {
      const  { displayName } =  await storageGetCurrentUser();
      console.log('clienteclientecliente ',displayName)
      setCompanyName( firstLetterUpperCase(displayName) )
    }



  const getDataTableSucursal = async() => {
    
    
    
      // modulo.sucursales                         nombre modulo           sub modulo        permission
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'view');


      if( !havePermissions ){


        await validateLsPermissions('No tienes pemisos para (listar) sucursales.');

    
          return false;

        
      }

      
      const response = await dispatch( getSucursalesStore() );


      const result = await validateResponse(response, ' (Listar Sucursal) ');

      if (!result) {
        return false;
      }

  }



  const validateResponse = async(response:any, textActionConcat: string) => {
          
          
        if (  response.code == 401  ) {
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          setModalSessionExpired(true);
          return false;
        }

      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 

        
          const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);

        
          return false;
          
        }

        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 

          const errors:any = [];

          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });

            
          setMessagesAlerts(errors);
          return false;

        }

        return true;
          
  }



  const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }


  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
  
    setRowsPerPage(+event.target.value);

    setPage(0);

  };



  const handleChangePage = (event: unknown, newPage: number) => {

        setPage(newPage);

  };



  const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
          
      setPagePagination(value)
  
      const response =  await dispatch( getSucursalesByPagination(value) );
      

      await validateResponse(response, ' (Listar Sucursales) ');
      
  
  };
  


  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center'
  }));

  // CONST VALUES 
  const open = Boolean(anchorEl);


  // CONST FUNCTIONS 
  

  const handleClose = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };

  //  CONST SSTYLES 
  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '7px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));
  


  const handleClick = (elem:any) => (event:any) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(elem);
  };

  




  const checkEdit = async() => {
                  
          
    const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'edit');
  
    if ( hasPermissionsEdit ) {
          setCanEdit(true);
    }

  }
      
      
  const checkCanDelete = async() => {
      
      
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'delete');
      
      if ( havePermissions ) {
            setCanDelete(true);
      }

  }
      
      
  const checkRestore = async() => {
      
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'restore');
        
      if ( havePermissions ) {
            setCanRestore(true);
      }

  }



  const detailSucursal = async (idSucursal:string) => {



        setAnchorEl(null);
        setOpenElem(null);
  
  
        const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'view');
    
        if( !havePermissions ){
    
          validateLsPermissions('No tienes pemisos para (ver) sucursal.');
    
          return false;                    
            
        }
  
  
        const response = await dispatch( storeDetailSucursal(idSucursal, setPercentage) );
  
        
        const result = await validateResponse(response, ' ( Ver Sucursal) ')
  
        if (!result) {
            return false;
        }
  
        if (response.ok) {
            navigate("/configuracion/sucursal/detalle-sucursal");
        }
        
  }




  const editSucursal = async (idSucursal:string) => {
  
    setAnchorEl(null);
    setOpenElem(null);
  
    const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'edit');

    if( !havePermissions ){

      validateLsPermissions('No tienes pemisos para (editar) sucursal.');

      return false;                    
        
    }


    const response = await dispatch( storeDetailSucursal(idSucursal, setPercentage) );

    const result = await validateResponse(response, ' ( Editar Sucursal) ')

    if (!result) {
        return false;
    }

    if (response.ok) {
        navigate("/configuracion/sucursal/editar-sucursal");
    }
    
  }



  const desactiveSucursal = async(sucursalId:string) => {
  
      setAnchorEl(null);
      setOpenElem(null);

    
      const response = await dispatch( storeDesactiveSucursal(sucursalId) );


      await validateResponse(response, ' (Desactivar Sucursal) ');

      
  }


  
  const activeSucursal = async(sucursalId:string) => {
  
    setAnchorEl(null);
    setOpenElem(null);

  
    const response = await dispatch( storeActiveSucursal(sucursalId) );


    await validateResponse(response, ' (Activar Sucursal) ');

    
}

  
  return (

    <>

      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

      {
              
              dataTableList.length > 0

              ?
                <>


                <Card
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      p: 3,
                      borderRadius: 2,
                      boxShadow: 3,
                      bgcolor: 'background.paper',
                      marginTop: paddingCardsTables
                    }}
                  >
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="right">Logo</StyledTableCell>
                          <StyledTableCell align="right">Nombre Sucursal</StyledTableCell>
                          <StyledTableCell align="right">Dirección</StyledTableCell>
                          <StyledTableCell align="right">Telefono Fijo</StyledTableCell>
                          <StyledTableCell align="right">Departamento</StyledTableCell>
                          <StyledTableCell align="right">Municipio</StyledTableCell>
                          <StyledTableCell align="right">Compañia</StyledTableCell>
                          <StyledTableCell align="right">Estado</StyledTableCell>
                          <StyledTableCell align="right">Acciones</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataTableList
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((sucursal:any, index:any) => (
                          <StyledTableRow key={sucursal.numero}>

                            <StyledTableCell align="right">
                              <AvatarTables urlImage={sucursal.logo} typeImage='branch' />
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                              {usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, sucursal.name)}
                            </StyledTableCell>
                            <StyledTableCell align="right">{usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, sucursal.address)}</StyledTableCell>
                            <StyledTableCell align="right">{sucursal.landline}</StyledTableCell>
                            <StyledTableCell align="right">{usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, sucursal.departament.name)}</StyledTableCell>
                            <StyledTableCell align="right">{usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, sucursal.municipaly.name)}</StyledTableCell>
                            <StyledTableCell align="right">
                              {usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, companyName)}
                            </StyledTableCell>
                            <StyledTableCell >
                            {
                              sucursal.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                            }
                          </StyledTableCell>
                          <StyledTableCell  >
                                
                          
                                {
                                
                                    <div> 
                                        {/* <Button
                                          id={`demo-customized-button-${index+1}`}
                                          aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={open ? 'true' : undefined}
                                          variant="text"
                                          disableElevation
                                          onClick={ handleClick(sucursal)}
                                          endIcon={<KeyboardArrowDownIcon />}
                                        > */}
                                        <Button
                                          id={`demo-customized-button-${index+1}`}
                                          aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={open ? 'true' : undefined}
                                          variant="text"
                                          disableElevation
                                          onClick={handleClick(sucursal)}
                                          endIcon={<KeyboardArrowDownIcon />}
                                        >
                                          Acciones
                                        </Button>
                                        <StyledMenu
                                          id={`demo-customized-menu-${index+1}`}
                                          MenuListProps={{
                                            'aria-labelledby': `demo-customized-button-${index+1}`,
                                          }}
                                          anchorEl={anchorEl}
                                          open={openElem === sucursal}
                                          onClose={handleClose}
                                        >
                                        {/* <StyledMenu
                                          id={`demo-customized-menu-${index+1}`}
                                          MenuListProps={{
                                            'aria-labelledby': `demo-customized-button-${index+1}`,
                                          }}
                                          anchorEl={anchorEl}
                                          open={openElem === sucursal}
                                          onClose={handleClose}
                                        > */}
                                          
                                          {
                                            (sucursal.status) 
                                              ? <div>
                                                <MenuItem onClick={ () => detailSucursal(sucursal.id) }  disableRipple>
       
                                                <VisibilityIcon />
                                                  Detalle 
                                                </MenuItem>
      
                                                {
                                                   canEdit && 
                                                      <>
                                                         <Divider sx={{ my: 0.5 }} />
                                                         <MenuItem onClick={ () => editSucursal(sucursal.id) }  disableRipple>
                                                           <EditIcon />
                                                             Editar
                                                        </MenuItem> 
                                                      </>
                                                }
                                              </div>
                                              :
                                              ''
                                          }
                                          
                                          {
                                            (sucursal.status) 
                                            ?
                                              <div>
                                                {
                                                   canDelete && 
                                                      <>
                                                          <Divider sx={{ my: 0.5 }} />
                                                          <MenuItem onClick={ () => desactiveSucursal(sucursal.id) } disableRipple>
                                                            <DeleteIcon />
                                                            Desactivar
                                                          </MenuItem>
                                                      </>
                                                }
                                              </div>
                                            :
                                            <div>
                                               {
                                                  canRestore && 
                                                       <>
                                                          <Divider sx={{ my: 0.5 }} />
                                                          <MenuItem onClick={ () => activeSucursal(sucursal.id) } disableRipple>
                                                            <DeleteIcon />
                                                            Activar
                                                          </MenuItem>
                                                       </>
                                               }
                                            </div>
                                            
                                          }
                                        </StyledMenu>
                                      </div>
                            
                                }
                
                
                
                
                                </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
                <TablePagination
                  rowsPerPageOptions={[5, 10]}
                  labelRowsPerPage={'Filas por pagina'}
                  labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
                  component="div"
                  count={pagination.itemCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={ handleChangePage }
                  onRowsPerPageChange={ handleChangeRowsPerPage }
                />
                <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 2,
                        marginBottom: 2
                      }}
                    >
                    <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
                </Box>

                </>
              :
              <Div>{"No hay Sucursales disponibles..."}</Div>

      }

      
    </>
  );
}


